import {
	IMPORT_DAYS_OFF,
	IMPORT_DAYS_OFF_ERROR,
	IMPORT_DAYS_OFF_SUCCESS,
} from '../../../constants';

export const importDaysOffReducer = (state, actions) => {
	switch (actions.type) {
		case IMPORT_DAYS_OFF:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case IMPORT_DAYS_OFF_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case IMPORT_DAYS_OFF_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				holidays: actions.payload,
			};
		default:
			return state;
	}
};
